import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-content">
        <nav className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/refund">Refund Policy</Link>
          <Link to="/contact">Contact Us</Link>
        </nav>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Carouselpost.in . All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Footer;